<div class="notification-center-container" (clickOutside)="showNotificationCenter(false)"
	[ngClass]="{ 'active': notificationCenterVisible }">
	<div class="notification-indicator" (click)="showNotificationCenter(!notificationCenterVisible)">
		<i class="fa notification-icon"
			[ngClass]="{ 'fa-bell': notificationCount > 0, 'fa-bell-o': notificationCount === 0 }"></i>
		<span class="notification-indicator__counter" [hidden]="notificationCount === 0">{{ notificationCount }}</span>
	</div>

	<div class="notification-center" [hidden]="!notificationCenterVisible">
		<div class="notification__placeholder" [hidden]="notificationCount !== 0">Currently no new notifications</div>
		<div class="notification" *ngFor="let group of this.notifications">

			<div class="notification__header">
				<span class="notification__closer" (click)="closeGroup(group, $event)"><i
						class="fa fa-times"></i></span>
				<span class="notification__title"><i class="fa" [ngClass]="group.icon"></i>{{ group.label }}</span>
				<span class="notification__time" [title]="group.latestDate | bbDate">{{ group.latestDate |
					bbDate:'relative' }}</span>
			</div>

			<div class="notification-item" [hidden]="group.items.length <= minSummarizeCount || !group.summarize">
				<a class="notification-item__summary" (click)="group.summarize = false">{{ group.items.length }} {{
					group.summarizeLabel }}<i class="fa fa-angle-down"></i></a>
			</div>

			<div class="notification-item" *ngFor="let notification of group.items"
				[hidden]="group.items.length > minSummarizeCount && group.summarize">
				<a *ngIf="notification?.entityUrl || notification?.group === 'version update'"
					class="notification-item__title" (click)="goToEntity(notification)">{{ notification.label }}</a>
				<a *ngIf="notification?.downloadUrl" [href]="notification.downloadUrl" target="_blank">{{
					notification.label }}</a>
			</div>

		</div>
	</div>
</div>
